module.exports = __webpack_public_path__ + "img/advanced-privacy.e76f9f37.webp";